// Components
import Head from './head';
import Layout from './layout';
import Loader from './loader';
import Nav from './nav';
import Menu from './menu';
import Side from './side';
import Social from './social';
import Email from './email';
import Footer from './footer';
// Sections
import Hero from './sections/hero';
import About from './sections/about';
import Jobs from './sections/jobs';
import Featured from './sections/featured';
import Projects from './sections/projects';
import Contact from './sections/contact';

export {
  Head,
  Layout,
  Loader,
  Nav,
  Menu,
  Side,
  Social,
  Email,
  Hero,
  About,
  Jobs,
  Featured,
  Projects,
  Contact,
  Footer,
};
